var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalaysia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_9602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_9602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_9602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 3H3V4.42666H33V3Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4.42666H3V5.85332H33V4.42666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 5.85332H3V7.27998H33V5.85332Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 7.28667H3V8.71333H33V7.28667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 8.71333H3V10.14H33V8.71333Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 10.14H3V11.5666H33V10.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 11.5733H3V13H33V11.5733Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 13H3V14.4267H33V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 14.4267H3V15.8533H33V14.4267Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15.86H3V17.2867H33V15.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 17.2867H3V18.7133H33V17.2867Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 18.72H3V20.1467H33V18.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 20.1467H3V21.5733H33V20.1467Z",
    fill: "#D81E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 21.5733H3V23H33V21.5733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.502 3H3V14.4334H20.502V3Z",
    fill: "#31409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68753 8.71332C7.68753 6.64366 9.15823 4.96248 10.9688 4.96248C11.5957 4.96248 12.1817 5.16342 12.6856 5.51841C12.0235 4.83522 11.1446 4.42665 10.1895 4.42665C8.12112 4.42665 6.43948 6.34896 6.43948 8.71332C6.43948 11.0777 8.12112 13 10.1895 13C11.1504 13 12.0235 12.5914 12.6856 11.9082C12.1875 12.2565 11.6016 12.4642 10.9688 12.4642C9.15823 12.4642 7.68753 10.783 7.68753 8.71332Z",
    fill: "#F5D02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 8.71334L16.9863 7.91628L15.0645 8.09043L16.3828 6.48293L14.7188 7.59478L15.293 5.49163L14.2148 7.32017L13.9395 5.14334L13.7402 6.70396L13.6816 7.15272L13.6582 7.32017L12.5801 5.49163L13.1602 7.59478L11.4961 6.48293L12.8086 8.09043L10.8926 7.91628L12.6855 8.71334L10.8926 9.51039L12.8086 9.33624L11.4961 10.9437L13.1602 9.83189L12.5801 11.935L13.6582 10.1065L13.6816 10.274L13.7402 10.7227L13.9395 12.2833L14.2148 10.1065L15.293 11.935L14.7188 9.83189L16.3828 10.9437L15.0645 9.33624L16.9863 9.51039L15.1875 8.71334Z",
    fill: "#F5D02C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_9602",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_9602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_9602",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/Malaysia.cc6ff2f77855320e2254c75aae7f67e3.svg";
export { ForwardRef as ReactComponent };